var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('span',{staticClass:"sign-enterprise-info"},[_vm._v("2016-2021 鲁ICP备18025351号 copyright ©️还有一些文字需要添加")])])}]

export { render, staticRenderFns }